<template>
  <div>
    <default-layout>
      <b-container
        class="text-center text-dark NotFound__section-wrapper p-0"
        fluid
      >
        <b-container class="NotFound__section-image">
          <b-row>
            <b-col>
              <h1 class="text-dark">
                404
              </h1>
            </b-col>
          </b-row>
        </b-container>
        <b-container>
          <b-row>
            <b-col class="pb-5">
              <p>the page you are looking for is not available</p>
            </b-col>
          </b-row>
        </b-container>
      </b-container>
    </default-layout>
  </div>
</template>

<script>
import DefaultLayout from '@/layouts/Default'

export default {
  components: { DefaultLayout },
  data () {
    return { pageContent: null }
  },
}
</script>

<style lang="scss" scoped>
.NotFound {
  &__section-wrapper {
  font-size: $spacer *1.3;
  }
  &__section-image {
  margin-top: 4em;
  width: 100%;
  height: 50vh;
  background-image: url(https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif);
  background-repeat: no-repeat;
  background-position: center;
}
}

</style>
